import React, { Fragment, useEffect, useRef } from 'react';

import { FlexColumn } from 'src/components/flex';
import { useLeadMessagesPageContext } from 'src/pages/landlord/leads/messages/context/hooks';
import Message from 'src/pages/landlord/leads/messages/components/messages-container/Message';
import ChannelSwitchDivider from 'src/pages/landlord/leads/messages/components/messages-container/ChannelSwitchDivider';
import { computeChannelSwitches } from 'src/pages/landlord/leads/messages/components/messages-container/utils/compute-channel-switches';

export default function LeadMessages() {
    const { messages } = useLeadMessagesPageContext();

    const messageContainerRef = useRef<HTMLDivElement>(null);

    const channelSwitches = computeChannelSwitches(messages);

    // Scroll to the bottom of the message container when a new message is added
    useEffect(() => {
        setTimeout(() => {
            const messageContainer = messageContainerRef.current;
            if (messageContainer) {
                messageContainer.scrollTop = messageContainer.scrollHeight;
            }
        }, 0);
    }, [messages?.length]);

    return (
        <FlexColumn
            ref={messageContainerRef}
            className="prettyScrollbar"
            flex={1}
            p={1}
            rowGap={0}
            maxWidth="100vw"
            sx={{ overflowY: 'scroll' }}
        >
            {messages.map((message, i) => {
                const switchedToChannel = channelSwitches[i];
                return (
                    <Fragment key={message.uuid}>
                        {switchedToChannel && <ChannelSwitchDivider channel={switchedToChannel} />}
                        <Message message={message} />
                    </Fragment>
                );
            })}

        </FlexColumn>
    );
}
